import {useSelector} from 'react-redux'
import {getAccommodationPageHotelId} from 'modules/accommodation/selectors'
import {getNumberOfRooms} from 'modules/sapiSearch/selectors'

import {Offer} from '@vio/core/src/offer/types/offer'
import {
  getDisplayPrice,
  getTotalPrice
} from '@vio/core/src/price/business/price'

import {PRICE_DIFF_PERCENTAGE_THRESHOLD} from './constants'

export const useRoomOfferPriceChangeAlert = ({
  offer,
  isOfferSoldOut,
  isCompact
}: {
  offer: Offer
  isOfferSoldOut: boolean
  isCompact: boolean
}) => {
  const {matchedOfferPriceDiff, isClicked, matchType} = offer
  const totalOfferPrice = getTotalPrice(getDisplayPrice(offer.prices))
  const hotelId = useSelector(getAccommodationPageHotelId)
  const numberOfRooms = useSelector(state => getNumberOfRooms(state, hotelId))

  // Price diff returned by SAPI is per 1 room, so we need to multiply it by the number of rooms
  const totalPriceDiff = matchedOfferPriceDiff * numberOfRooms

  const isPriceDiffPercentageThresholdExceeded =
    totalOfferPrice > 0 &&
    Math.abs(totalPriceDiff / totalOfferPrice) > PRICE_DIFF_PERCENTAGE_THRESHOLD

  const isPriceChangeBannerVisible =
    isClicked &&
    matchType === 'by_terms' &&
    !isOfferSoldOut &&
    !isCompact &&
    isPriceDiffPercentageThresholdExceeded

  return {
    isPriceChangeBannerVisible,
    priceDiff: totalPriceDiff
  }
}
